// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#download[data-v-0b450ab8]{background-image:url(http://file.sl.dande.online/static/landing/template/bgDownload.jpg);background-attachment:fixed;background-repeat:no-repeat;background-size:cover;background-position:50%;height:500px}#download .container[data-v-0b450ab8],#download .row[data-v-0b450ab8]{height:100%}", ""]);
// Exports
module.exports = exports;
